<template>
  <section id="hero" class="d-flex flex-column justify-content-center align-items-center">
    <div class="container text-center text" data-aos="fade-up">
      <h1 style="font-family: serif; font-weight: normal; font-size: 70px">GIORGIO</h1>

      <h2>parrucchieri<span style="color: rgb(240, 224, 110)">|</span>hair spa<span style="color: rgb(240, 224, 110)">|</span>estetica</h2>

      <h3>NON IMITARE. <span style="color: rgb(240, 224, 110)">LASCIATI</span> IMITARE</h3>
      <!--<a href="#about" class="btn-get-started scrollto">Get Started</a>-->
    </div>
  </section>
</template>

<script>
</script>

<style scoped>
#hero {
  width: 100%;
  height: calc(100vh - 72px);
  /* background: url("../img/home.jpg") center center;
  background: url("../img/logo.jpg") center center;*/
  background-color: rgb(50, 50, 50);
  position: relative;
  margin-top: 72px;
  padding: 0;
}

#hero:before {
  content: "";
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
}

#hero .container {
  z-index: 2;
}

#hero h1 {
  margin: 0 0 10px 0;
  font-size: 48px;
  font-weight: 700;
  line-height: 56px;
  color: white;
}

#hero h2 {
  color: white;
  margin-bottom: 35px;
  font-size: 24px;
  font-family: revert;
  font-weight: lighter;
}

#hero h3 {
  color: white;
  margin-bottom: 35px;
  font-size: 24px;
  margin-top: 2em;
  font-family: serif;
}

#hero .btn-get-started {
  font-family: "Raleway", sans-serif;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 8px 28px;
  border-radius: 4px;
  transition: 0.5s;
  border: 2px solid #fff;
  color: #fff;
}

#hero .btn-get-started:hover {
  border-color: #1bac91;
  background: #1bac91;
}

@media (min-width: 1024px) {
  #hero {
    background-attachment: fixed;
  }
}

@media (max-width: 992px) {
  #hero {
    margin-top: 60px;
    height: calc(100vh - 60px);
  }
}

@media (max-width: 768px) {
  #hero h1 {
    font-size: 28px;
    line-height: 36px;
  }
  #hero h2 {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 30px;
  }
}
</style>
